import React from 'react';
import PropTypes from 'prop-types';

import LoginFormContainerV2 from 'dpl/auth/containers/LoginFormContainerV2';

export default function UserAuthModalLoginFormV2({
  onAuth,
  onPasswordResetClick,
  loginOnly
}) {
  return (
    <div className="UserAuthModalLoginForm bg-sand br4">
      <LoginFormContainerV2
        hideForgotPassword={!onPasswordResetClick}
        onPasswordResetClick={onPasswordResetClick}
        onAuth={onAuth}
        loginOnly={loginOnly}
      />
    </div>
  );
}

UserAuthModalLoginFormV2.propTypes = {
  onAuth: PropTypes.func.isRequired,
  onPasswordResetClick: PropTypes.func,
  loginOnly: PropTypes.bool
};

UserAuthModalLoginFormV2.defaultProps = {
  loginOnly: false,
  onPasswordResetClick: null
};
